import { VettingApi } from "@/api/vetting";
import { ReissuePaymentLinkRequest } from "@/api/vetting/types/reissue-payment-link.types";
import { useMutation } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useReissuePaymentLink = () => {
  const notify = useNotify();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: ReissuePaymentLinkRequest) =>
      VettingApi.reissuePaymentLink(body),
    onError: (error) => {
      notify(error, { type: "error" });
    },
    onSuccess: () => {
      notify("Payment link sent via SMS", { type: "success" });
    },
  });

  return {
    reissuePaymentLink: mutate,
    isReissueLoading: isPending,
  };
};
